module.exports = __webpack_public_path__ + "static/media/logo.a577b93e.png";